import Vuex, { Store } from "vuex";
import { createLocalVue, mount } from "@vue/test-utils";
import ProgressBar from "@/components/core/ProgressBar";

const localVue = createLocalVue();
localVue.use(Vuex);

describe("ProgressBar component", () => {
  let wrapper;
  let store;
  let getters;

  const props = {
    percentage: 5
  };

  beforeEach(() => {
    getters = {
      getRoute: function () {
        return () => ({
          route: {}
        });
      }
    };

    store = new Store({ getters });

    wrapper = mount(ProgressBar, {
      store,
      localVue,
      propsData: props
    });
  });

  it("Renders del component ProgressBar", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
